import { Box, Button, FormikField as Field, Input, Text } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { Form, Formik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';

import { target } from '../FlowConfig';

type Props = {};

type FormValues = Yup.InferType<typeof target>;

export const TargetStep: React.FC<Props> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  const initialValues: FormValues = {
    amount: undefined,
    month: '',
    year: '',
  };

  const handleSubmit = (values: FormValues) => {};

  return (
    <WorkflowLayout pageTitle="Set your investing target">
      <WorkflowLayout.Header
        workflowTitle="Set your investing target"
        onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
      />
      <WorkflowLayout.Content>
        <Text>Pick a target for how much and when you want your money. You can always change it later.</Text>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={target}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <Form>
            <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
              <Field name="amount">
                <Field.Label>Target amount (Optional)</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>
              <Box>
                <Field name="month">
                  <Field.Label>Target date</Field.Label>
                  <Field.Control>
                    <Input />
                  </Field.Control>
                  <Field.ErrorMessage />
                </Field>
                <Field name="year">
                  <Field.Control>
                    <Input />
                  </Field.Control>
                  <Field.ErrorMessage />
                </Field>
              </Box>

              <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
                Continue
              </Button>
            </Box>
          </Form>
        </Formik>
      </WorkflowLayout.Content>
    </WorkflowLayout>
  );
};
